// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-pdf-embed{margin:auto}.vue-pdf-embed canvas{width:100%!important;height:auto!important}", ""]);
// Exports
module.exports = exports;
